import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import updateUserInfo from '../../api/updateUserInfo';
import getUserInfo from '../../api/userinfo';
import resetStore from '../resetStore';

export const fetchUserInfo = createAsyncThunk(
  'user/fetchUserInfo',
  async (_, { rejectWithValue }) => {
    try {
      const user = await getUserInfo();
      return user;
    } catch (err) {
      const dataError =
        err.code === 'ERR_NETWORK'
          ? 'Отсутствует подключение к интернету'
          : err.response?.data?.message || 'Не удалось загрузить данные пользователя';
      return rejectWithValue(dataError);
    }
  }
);

export const updateUserInfoThunk = createAsyncThunk(
  'user/updateUserInfo',
  async (fields, { rejectWithValue }) => {
    try {
      const user = await updateUserInfo(fields);
      return user;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || 'Не удалось изменить данные пользователя'
      );
    }
  }
);

const initialState = {
  data: {},
  fetchStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  updateStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action) {
      state.data = action.payload;
    },
    updateUser(state, action) {
      state.data = { ...state.data, ...action.payload };
    },
    setErrorUser(state, action) {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchUserInfo
      .addCase(fetchUserInfo.pending, (state) => {
        state.fetchStatus = 'loading';
        state.error = null;
      })
      .addCase(fetchUserInfo.fulfilled, (state, action) => {
        state.fetchStatus = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchUserInfo.rejected, (state, action) => {
        state.fetchStatus = 'failed';
        state.error = action.payload;
      })

      // updateUserInfoThunk
      .addCase(updateUserInfoThunk.pending, (state) => {
        state.updateStatus = 'loading';
        state.error = null;
      })
      .addCase(updateUserInfoThunk.fulfilled, (state, action) => {
        state.updateStatus = 'succeeded';
        state.data = action.payload;
      })
      .addCase(updateUserInfoThunk.rejected, (state, action) => {
        state.updateStatus = 'failed';
        state.error = action.payload;
      })

      // reset store (опционально)
      .addCase(resetStore, () => initialState);
  },
});

export const { setUser, updateUser, setErrorUser } = userSlice.actions;
export default userSlice.reducer;
